module.exports = __webpack_public_path__ + "static/media/lu-logo2.5cdaa187.svg";